import { schema } from "normalizr";

const platformSchema = new schema.Entity("platforms", {}, { idAttribute: "name" });
const clientSchema = new schema.Entity("clients");

clientSchema.define({
  platforms: [platformSchema]
});


export { platformSchema, clientSchema };
